// Define your action types
export const SET_USER = 'SET_USER';